var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("el-input", {
    attrs: { value: _vm.value },
    on: { input: _vm.onInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }